<div class="hospital-registration-container">
  <div class="registration-header">
    <!-- Home Button (top-left or top-right) -->
   <button mat-icon-button aria-label="Go to home" (click)="goHome()">
  <mat-icon style="color: rgb(27, 75, 27);">home</mat-icon> Home
</button>

    <div class="header-content">
      <h1 style="color: var(--mat-sys-primary);">Hospital Registration</h1>
      <p>Register your healthcare organization to start providing services</p>
    </div>
  </div>

  @if(hospitalFormFields && hospitalFormMetaData) {
    <div class="form-wrapper">
      <app-dynamic-forms-v2
        [formFields]="hospitalFormFields"
        [formMetaData]="hospitalFormMetaData"
        [resetOnSubmit]="false"
        (formSubmitted)="onFormSubmit($event)">
      </app-dynamic-forms-v2>
    </div>
  }
</div>
